import React, { useState } from 'react';
import TooltipIcon from '../../images/tooltip-icon.svg';
import CountryField from '../CountryField';
import {
	getHappinessLabel,
	getCostOfLiving,
} from '../Table/columns/quality.js';
import { Link } from 'gatsby';

const ModalTooltip = () => {
	return (
		<div
			className="
	modal__content
	--without-margins
	--with-paddings
	bg:light-grey
	mt-2
	mb-2
"
		>
			<div className="modal-row-info">
				<h3>Score</h3>
				<div>
					<p className="mb-2">
						The Quality of Life index is worth 25% of the Global
						Passport Index score. To measure the quality of life six
						indicators were measured: sustainable development
						(weighted at 30% of the quality of life score), the cost
						of living (weighted at 20%), the protection of personal
						freedom (weighted at 20%), the “happiness” of the
						citizens (weighted at 10%), environmental performance
						(weighted at 10%), and migrant acceptance (weighted at
						10%).
					</p>
					<p>
						This table provides a visual representation of three
						indicators: Sustainable Development, Cost of Living, and
						the level of “happiness” of the citizens.
					</p>
				</div>
			</div>
		</div>
	);
};

export const QualityModal = (props) => {
	const {
		setIsModalOpen,
		country,
		eqol_points,
		whr_idx_value,
		col_idx_value,
		iso2c,
	} = props;
	return {
		HeaderComponent: () => <CountryField code={iso2c} />,
		BodyComponent: () => {
			const [isTooltipVisible, setTooltipVisibility] = useState(false);
			return (
				<main
					className="modal__content pt-0"
					id="filter-continent-content"
				>
					<div>
						<div className="modal-row">
							<h2>
								Quality of life ranking score{' '}
								{!isTooltipVisible && (
									<img
										onClick={() =>
											setTooltipVisibility(true)
										}
										src={TooltipIcon}
									/>
								)}
							</h2>
							<div>{eqol_points}</div>
						</div>
						{isTooltipVisible && <ModalTooltip />}
						<div className="modal-row">
							<h2>Quality of life</h2>
							<div>Low</div>
						</div>
					</div>

					<div>
						<div className="modal-row">
							<h2>Cost of Living</h2>
							<div>{getCostOfLiving(col_idx_value)}</div>
						</div>
						<div className="modal-row">
							<h2>Happiness</h2>
							<div>{getHappinessLabel(whr_idx_value)}</div>
						</div>
					</div>
				</main>
			);
		},
		FooterComponent: () => {
			const countryCode = iso2c?.toLowerCase() || country?.toLowerCase();
			const link = `/countries/${countryCode}`;
			return (
				<Link
					to={link}
					className="modal__btn btn btn__primary"
					aria-label="Close this dialog window"
				>
					Country detail
				</Link>
			);
		},
	};
};
